module.exports = __webpack_public_path__ + "static/media/socialbar-nobg.fa1e27e4.png";